import type { ReactNode } from 'react';
import { RefreshCw } from 'lucide-react';
import { useEngineUpdating } from './engine-updating';

/** The one line the workbench shows while its engine calls wait out a release (engine-updating.ts). */
export function EngineUpdatingNotice(): ReactNode {
  if (!useEngineUpdating()) return null;
  return (
    <div className="paige-upload-progress" role="status" aria-live="polite">
      <RefreshCw size={15} aria-hidden="true" />
      <span>Paige is updating. Your work is safe and carries on in a moment.</span>
    </div>
  );
}
